import { Link } from 'react-router-dom';
import { MapPin, Home, ArrowRight } from 'lucide-react';
import { Badge } from '../ui/badge';

export const ProjectCard = ({ project, variant = 'default' }) => {
  const statusColors = {
    Ongoing: 'bg-[#47ace2] text-white',
    Completed: 'bg-emerald-500 text-white',
    Upcoming: 'bg-amber-500 text-white',
  };

  // Support both camelCase (static data) and snake_case (API response)
  const priceRange = project.price_range || project.priceRange;
  const images = project.images || [];
  const configurations = project.configurations || [];

  if (variant === 'compact') {
    return (
      <Link
        to={`/projects/${project.id}`}
        data-testid={`project-card-${project.id}`}
        className="group block bg-white border border-slate-100 rounded-2xl overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
      >
        <div className="relative aspect-[4/3] overflow-hidden">
          {images[0] && (
            <img
              src={images[0]}
              alt={project.name}
              className="w-full h-full object-contain bg-slate-50 group-hover:scale-105 transition-transform duration-500"
            />
          )}
          <Badge className={`absolute top-4 left-4 ${statusColors[project.status]}`}>
            {project.status}
          </Badge>
        </div>
        <div className="p-5">
          <h3 className="text-lg font-semibold text-slate-900 font-outfit group-hover:text-[#47ace2] transition-colors">
            {project.name}
          </h3>
          <div className="flex items-center gap-1 text-slate-500 text-sm mt-2 font-manrope">
            <MapPin className="w-4 h-4" />
            {project.location}
          </div>
          <p className="text-[#47ace2] font-semibold mt-3 font-manrope">{priceRange}</p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/projects/${project.id}`}
      data-testid={`project-card-${project.id}`}
      className="group block bg-white border border-slate-100 rounded-2xl overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        {images[0] && (
          <img
            src={images[0]}
            alt={project.name}
            className="w-full h-full object-contain bg-slate-50 group-hover:scale-105 transition-transform duration-500"
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        <Badge className={`absolute top-4 left-4 ${statusColors[project.status]}`}>
          {project.status}
        </Badge>
        <Badge className="absolute top-4 right-4 bg-white/90 text-slate-700">
          {project.category}
        </Badge>
      </div>
      <div className="p-6">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h3 className="text-xl font-semibold text-slate-900 font-outfit group-hover:text-[#47ace2] transition-colors">
              {project.name}
            </h3>
            <div className="flex items-center gap-1 text-slate-500 text-sm mt-2 font-manrope">
              <MapPin className="w-4 h-4" />
              {project.location}
            </div>
          </div>
        </div>
        
        <div className="flex items-center gap-4 mt-4">
          <div className="flex items-center gap-1 text-slate-600 text-sm font-manrope">
            <Home className="w-4 h-4" />
            {project.type}
          </div>
          {configurations[0] && (
            <>
              <span className="text-slate-300">|</span>
              <span className="text-slate-600 text-sm font-manrope">{configurations[0]}</span>
            </>
          )}
        </div>

        <div className="flex items-center justify-between mt-5 pt-4 border-t border-slate-100">
          <p className="text-[#47ace2] font-semibold font-manrope">{priceRange}</p>
          <span className="flex items-center gap-1 text-slate-500 group-hover:text-[#47ace2] text-sm font-medium transition-colors">
            View Details
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </span>
        </div>
      </div>
    </Link>
  );
};
